export const LAUNCHPICKERINPUT = "LaunchPickerInput";
export const LAUNCHDATEPICKERINPUT = "LaunchDatePickerInput";
export const LAUNCHPICKERMULTISELECT = "LaunchPickerMultiSelect";
export const LAUNCHAUTOSEARCHBOX = "LaunchAutoSearchBox";
